// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Xmv4W","form":"styles_form__VUmJf","formcolumns":"styles_formcolumns__i6NmG"};